// extracted by mini-css-extract-plugin
export default {"oAuthContainer":"OAuth_oAuthContainer__5rGkw","extraInfo":"OAuth_extraInfo__3l5jF","infoBlock":"OAuth_infoBlock__iCjYZ"};